module.exports = __webpack_public_path__ + "assets/184ad4d4319ce40cca0149d3864cf102.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/mystery/DuringXtraBell.mp3
 ** module id = 348
 ** module chunks = 0
 **/